export class Envolvido {
  tipoEnvolvido:number;
  codigoAluno?: number;
  codigoChamado?: number;
  tipoPessoa?: number;
  dsTipoPessoa?:string;
  cpf?:string;
  ra?:string;
  nome?: string;
  dsOutros?:string;
  imagemTemporaria?: string;
  idTemporario?: number;
  codigoTurma?: number;
  descricaoTurma?: string;
  cdEnvolvido?: number;
  codigoEnvolvido?: number;
  foto?:string;
  temFoto?:boolean;
  iniciais?:string;
  status?:number;
  statusS?:string;
  dsEnvolvido?:string;
  escola?:string;
  diretoria?:string;
  codigoEscola?: number;
  codigoDiretoria?: number;
  numeroClasse?: number;
  nomeTipoEnsino?: string;
  numeroSerie?: number;
  dsEstatusEnvolvido?: string;
  nomeEnvolvido?: string;
  }
